import React from 'react';
const ThumbsUpSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
    >
      <path
        d="M9.70105 3.6C9.45533 3.30857 9.10105 3.14286 8.71819 3.14286H6.41534V1.57143C6.41534 0.702857 5.71248 0 4.79819 0C4.39819 0 4.03819 0.24 3.87819 0.611429L2.42676 4H1.35819C0.609621 4 0.00390625 4.60571 0.00390625 5.35429V8.65143C0.00390625 9.39429 0.615335 10 1.35819 10H7.96391C8.58676 10 9.11819 9.55429 9.22676 8.93714L9.98105 4.65143C10.0439 4.27429 9.94105 3.89143 9.69533 3.6H9.70105ZM1.35819 9.14286C1.08391 9.14286 0.861049 8.92 0.861049 8.65143V5.35429C0.861049 5.08 1.08391 4.85714 1.35819 4.85714H2.27819V9.14286H1.35819ZM8.38676 8.78857C8.35248 8.99429 8.17533 9.14286 7.96391 9.14286H3.14105V4.51429L4.66676 0.942857C4.68962 0.891429 4.74105 0.851428 4.84962 0.851428C5.24391 0.851428 5.55819 1.17143 5.55819 1.56571V3.99429H8.71819C8.84962 3.99429 8.96391 4.04571 9.04391 4.14286C9.12391 4.24 9.15819 4.36571 9.13533 4.49714L8.38105 8.78286L8.38676 8.78857Z"
        fill="white"
      />
    </svg>
  );
};

export default ThumbsUpSVG;
